import { RouteObject } from "react-router-dom";
import { BusinesFunctionDetailPage } from "src/components/change-log/BusinessFunctionDetailsPage";
import { BusinessFunctionsPage } from "src/components/change-log/BusinessFunctionsPage";
import { ChangeTypesPage } from "src/components/change-log/ChangeTypesPage";
import { ChangeLogPage } from "src/routes/change-log/ChangeLogPage";
import { NotFound } from "src/routes/NotFound";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import * as changeLogPaths from "src/routing/domains/changeLogPaths";

/**
 * `/change-log/*` route tree.
 *
 * Role: data router domain route.
 *
 * Two layout stacks coexist during migration:
 * - **New (Beam):** `AppShell` → `BeamNavbarLayout` → page (Change Log / Change Types)
 * - **Legacy:** `AppShell` → `GlobalNavLayout` → page (Functions)
 *
 * Path constants live in `changeLogPaths.ts` (imported by `RouteUrls.ts` / pages) to avoid a cycle
 * through this file's page `Component` imports.
 */
const changeLogDomainRoute: RouteObject = {
  path: changeLogPaths.changeLogRoute.path,
  Component: AppShell,
  children: [
    {
      Component: BeamNavbarLayout,
      children: [
        { index: true, Component: ChangeLogPage },
        { path: `${changeLogPaths.changeLogDetailsRoute.path}/*`, Component: ChangeLogPage },
        { path: changeLogPaths.changeTypesRoute.path, Component: ChangeTypesPage },
      ],
    },
    {
      Component: GlobalNavLayout,
      children: [
        { path: changeLogPaths.businessFunctionsRoute.path, Component: BusinessFunctionsPage },
        { path: changeLogPaths.businessFunctionDetailsRoute.path, Component: BusinesFunctionDetailPage },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};

/**
 * Migrated `/change-log/*` route trees registered in `Router.tsx`.
 */
export const changeLogRoutes = [changeLogDomainRoute];
